import professionalPlugin from "./plugins/professional";

export const exportProduct = async (productId: string) => {
  return professionalPlugin.export(productId);
};
